export enum SeverityValueEnum {
  S1_TOOL_DOWN = 'S1_ToolDown',
  S1_SAFETY_ISSUE_PI = 'S1_SafetyIssue_Pi',
  S2_HIGH_IMPACT_ISSUE = 'S2_HighImpactIssue',
  S3_MEDIUM_IMPACT_ISSUE = 'S3_MediumImpactIssue',
  S4_LOW_IMPACT_ISSUE = 'S4_LowImpactIssue',
  S4_REQUEST_FOR_INFORMATION = 'S4_RequestForInformation',
}
